import { render, staticRenderFns } from "./NotifyBroadcast.vue?vue&type=template&id=516c787b&scoped=true"
import script from "./NotifyBroadcast.vue?vue&type=script&lang=js"
export * from "./NotifyBroadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c787b",
  null
  
)

export default component.exports